import { render, staticRenderFns } from "./PrenatalRapidTrio.vue?vue&type=template&id=317ead9a"
import script from "./PrenatalRapidTrio.vue?vue&type=script&lang=js"
export * from "./PrenatalRapidTrio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports